import * as React from "react";

interface ResultsContextState {
    showBestValues: boolean;
    showPredictedValues: boolean;
    showPercentagePredicted: boolean;
    additionalColumnCount?: number;
}

export const ResultsContext = React.createContext<ResultsContextState | undefined>(undefined);

export const useResultsContext = (): ResultsContextState => {
    const context = React.useContext(ResultsContext);
    if (context === undefined) {
        throw new Error('useResultsContext must be used within a ResultsContext Provider')
    }

    let additionalColumnCount = 1;
    additionalColumnCount += context.showBestValues ? 1 : 0;
    additionalColumnCount += context.showPredictedValues ? 1 : 0;
    additionalColumnCount += context.showPercentagePredicted ? 1 : 0;

    return {
        ...context,
        additionalColumnCount,
    };
}
